import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/App";
import { UserPlus, Menu, X } from "lucide-react";

export const COMPANY_LOGO = "https://customer-assets.emergentagent.com/job_bizcommerce-19/artifacts/7hv4d1j9_LOGO%20PNG.png";

const LINKS = [
  { key: "home", label: "Home", to: "/" },
  { key: "about", label: "About Us", to: "/about" },
  { key: "crm", label: "CRM", href: "https://crm.veyronix.co.uk" },
  { key: "commerce", label: "Commerce", to: "/commerce" },
  { key: "ai-studio", label: "AI Studio", to: "/ai-studio" },
  { key: "pulse", label: "PULSE", to: "/pulse" },
  { key: "pricing", label: "Pricing", to: "/pricing" },
];

const NavItem = ({ l, active, className, onClick }) => {
  const cls = `${className} ${active === l.key ? "text-white font-medium" : "text-slate-400 hover:text-white"} transition-colors`;
  const props = { className: cls, "data-testid": `nav-${l.key}`, onClick, "aria-current": active === l.key ? "page" : undefined };
  return l.href ? <a href={l.href} {...props}>{l.label}</a> : <Link to={l.to} {...props}>{l.label}</Link>;
};

export const SiteNav = ({ active }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <nav className="sticky top-0 z-50 bg-slate-900/95 backdrop-blur-md border-b border-slate-800" aria-label="Main">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 flex-shrink-0" aria-label="Veyronix home">
            <img src={COMPANY_LOGO} alt="" className="h-9 w-auto brightness-0 invert" />
            <div className="h-7 w-px bg-white/20" />
            <span className="text-white font-brand text-lg font-bold tracking-tight">VEYRONIX</span>
          </Link>
          <div className="hidden lg:flex items-center gap-7">
            {LINKS.map(l => <NavItem key={l.key} l={l} active={active} className="text-sm" />)}
          </div>
          <div className="flex items-center gap-3">
            {user ? (
              <Button onClick={() => navigate(user.role === "admin" ? "/admin" : user.role === "merchant" ? "/merchant" : "/dashboard")} size="sm" className="bg-indigo-600 hover:bg-indigo-500 text-white text-sm">Dashboard</Button>
            ) : (
              <>
                <Button onClick={() => navigate("/login")} variant="ghost" className="hidden sm:inline-flex text-slate-300 hover:text-white hover:bg-white/5 text-sm" size="sm">Sign In</Button>
                <Button onClick={() => navigate("/register")} size="sm" className="hidden sm:inline-flex bg-indigo-600 hover:bg-indigo-500 text-white text-sm">
                  <UserPlus className="h-3.5 w-3.5 mr-1.5" />Sell on Veyronix
                </Button>
              </>
            )}
            <button type="button" className="lg:hidden p-2 text-slate-300 hover:text-white" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? "Close menu" : "Open menu"} data-testid="nav-mobile-toggle">
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
        {open && (
          <div id="mobile-nav" className="lg:hidden border-t border-slate-800 py-3 flex flex-col" data-testid="nav-mobile-menu">
            {LINKS.map(l => <NavItem key={l.key} l={l} active={active} className="py-2.5 text-base" onClick={() => setOpen(false)} />)}
            {!user && (
              <div className="flex gap-3 pt-3 sm:hidden">
                <Button onClick={() => navigate("/login")} variant="outline" size="sm" className="flex-1 border-slate-700 bg-transparent text-slate-200">Sign In</Button>
                <Button onClick={() => navigate("/register")} size="sm" className="flex-1 bg-indigo-600 text-white">Sell on Veyronix</Button>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};
